import { createApi } from '@viewstream/api-client';
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@viewstream/api-client';
import { recordApiResponse } from './supportContext';

/** Fired on any 401 so the router can send the user to /login with a return URL (foundation spec "Session expired"). */
export const unauthorized = new EventTarget();

export const api = createApi({
  baseUrl: import.meta.env['VITE_API_BASE'] ?? '',
  onUnauthorized: () => unauthorized.dispatchEvent(new Event('unauthorized')),
});

// change support-requests: remember the last request ids / errors for "Contact support" (memory only). Added after the
// client's own middleware, so its onResponse runs first — before a failed response is turned into an ApiError.
api.use({
  async onResponse({ request, response }) {
    try { await recordApiResponse(request, response); } catch { /* never break a call */ }
    return undefined;
  },
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (count, err) => !(err instanceof ApiError && (err.status === 401 || err.status === 403 || err.status === 404)) && count < 2,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: 0 },
  },
});
